import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import EditorCloseIcon from '@atlaskit/icon/glyph/editor/close';
import EditorDoneIcon from '@atlaskit/icon/glyph/editor/done';
import React from 'react';
import { AnswerTemplate } from '../CustomerComponents/AnswerTemplate';
import { NoPartnerResponseText } from '../CustomerComponents/NoPartnerResponseText';
import { QuestionTemplate } from '../CustomerComponents/QuestionTemplate';
import { RichComponent } from '../CustomerComponents/RichComponent';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Priority
 * -> Response not provided - no icon
 * -> iconBefore defined for the QnA
 * -> Answer text contains "No" - Appropriate icon
 * -> Anything else default icon
 */
const getIconBefore = (answerAsConfig, iconBefore) => {
  var _answerAsConfig$;
  if (!answerAsConfig) {
    return null;
  }
  if (iconBefore) {
    return iconBefore;
  }

  // Typecasted as we only care about showing the appropriate icon
  // for "No". Check 'yesNoNull' function to understand how the
  // ui config for that looks like
  const text = (_answerAsConfig$ = answerAsConfig[0]) === null || _answerAsConfig$ === void 0 ? void 0 : _answerAsConfig$.text;
  const answerText = text === null || text === void 0 ? void 0 : text.toLowerCase();
  if (answerText !== null && answerText !== void 0 && answerText.includes('no')) {
    return /*#__PURE__*/_jsx(EditorCloseIcon, {
      label: ""
    });
  }
  return /*#__PURE__*/_jsx(EditorDoneIcon, {
    label: ""
  });
};
export const getQnA = (qna, transformedAppTrustData) => qna.map(_ref => {
  let {
    question,
    answer,
    iconBefore
  } = _ref;
  // --- Question ---
  const questionAsConfig = question(transformedAppTrustData);
  const Question = /*#__PURE__*/_jsx(QuestionTemplate, {
    children: questionAsConfig.map((config, index) => /*#__PURE__*/_jsx(RichComponent, _objectSpread({}, config), index))
  });

  // ---- Answer ----
  const answerAsConfig = answer(transformedAppTrustData);
  const Answer = /*#__PURE__*/_jsx(AnswerTemplate, {
    iconBefore: getIconBefore(answerAsConfig, iconBefore),
    children: answerAsConfig ? answerAsConfig.map((config, index) => /*#__PURE__*/_jsx(RichComponent, _objectSpread({}, config), index)) : /*#__PURE__*/_jsx(NoPartnerResponseText, {
      byAtlassian: transformedAppTrustData.byAtlassian
    })
  });
  return {
    question: Question,
    answer: Answer
  };
});
export default getQnA;